import { sha256 as jsSha256 } from 'js-sha256';

export async function sha256(source: string) {
  try {
    const sourceBytes = new TextEncoder().encode(source);
    const digest = await crypto.subtle.digest('SHA-256', sourceBytes);
    return bufferToString(digest);
  } catch {
    try {
      return Promise.resolve(jsSha256.update(source).arrayBuffer()).then(bufferToString);
    } catch {
      return source
        .split('"')
        .map(v => v.length)
        .join(', ')
        .toString();
    }
  }
}

function bufferToString(buffer: ArrayBuffer): string {
  return [...new Uint8Array(buffer)]
    .map(x => x.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 14);
}
